import React, { useEffect, useState } from "react";
import { getUserActivityAPI, getUsersByTypeAPI } from "../service/AuthService";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";

export default function LoginReport() {
  const location = useLocation();
  console.log(location)
  const params = useParams();

  const [payload, setPayload] = useState({
    activityLogType: "LOGIN",
    from: moment()
      .subtract(7, "d")
      .toISOString(),
    to: moment().toISOString(),
    userName: location?.state?.username,
    pageSize: 100,
  });
  const [data, setData] = useState([]);

  const [users, setUsers] = useState([]);
  const getUsersByType = async () => {
    const { response, code } = await getUsersByTypeAPI(
      params?.userType?.toLocaleUpperCase()
    );
    if (code === 200) {
      setUsers(response?.users);
    }
  };
  const getUserActivity = async () => {
    const { response, code } = await getUserActivityAPI(payload);
    if (code == 200) {
      setData(response?.content);
    }
  };
  useEffect(() => {
    getUsersByType();
  }, [params]);

  useEffect(() => {
    getUserActivity();
    setPayload({
      ...payload,
      userName: location?.state?.username,
    })
  }, [location?.state]);


  const userOptions = [
    {
      value: 0,
      label: `All ${params?.userType?.toUpperCase()}`,
    },
    ...users.map((user) => ({
      value: user.userName,
      label: user.userName + ' ' + (user.name),
    })),
  ];

  return (
    <div className="content-wrapper" style={{ minHeight: "1448.29px" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">Login Report</div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active text-capitalize">
                  {params?.userType?.toLocaleUpperCase()} Login Reports
                </li>
              </ol>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card">
                <div method="post">
                  <input
                    type="hidden"
                    name="_csrf"
                    defaultValue="81e63a0d-809f-416f-86bb-6e73b5e60768"
                  />
                  <div className="card-header bg-gradient-purple">
                    <div className="form-row">
                      <div className="form-group col-md-3">
                        <label htmlFor="name" className="text-capitalize">
                          {params?.userType?.toLocaleUpperCase()}
                        </label>
                        <Select
                          options={userOptions}
                          placeholder="Select Client"
                          value={userOptions.find(
                            (opt) => opt.value === payload.userName
                          )}
                          onChange={(selectedOption) =>
                            setPayload({
                              ...payload,
                              userName: selectedOption.value,
                            })
                          }
                          isSearchable
                        />
                        {/* <select
                          className="form-control "
                          required=""
                          onChange={(e) =>
                            setPayload({
                              ...payload,
                              userName: e.target.value,
                            })
                          }
                          id="name"
                          placeholder="Select Client"
                          name="client"
                          data-select2-id="name"
                          tabIndex={-1}
                          aria-hidden="true"
                        >
                          <option value={0} data-select2-id={2}>
                            {" "}
                            All {params?.userType?.toLocaleUpperCase()}{" "}
                          </option>
                          {users.map((user) => (
                            <option key={user.id} value={user.userName}>
                              {user.userName}
                            </option>
                          ))}
                        </select> */}
                      </div>
                      <div className="form-group col-md-3">
                        <div className="form-group">
                          <label htmlFor="from">Date From</label>
                          <div className="input-group">
                            <input
                              type="date"
                              value={
                                payload.from
                                  ? moment(payload.from).format("YYYY-MM-DD")
                                  : ""
                              }
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  from: moment(e.target.value, "YYYY-MM-DD").toISOString(),
                                })
                              }
                              className="form-control"
                              id="from"
                              name="from"
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <i className="fa fa-calendar" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group col-md-3">
                        <div className="form-group">
                          <label htmlFor="to">Date To</label>
                          <div className="input-group">
                            <input
                              type="date"
                              value={
                                payload.to
                                  ? moment(payload.to).format("YYYY-MM-DD")
                                  : ""
                              }
                              onChange={(e) =>
                                setPayload({
                                  ...payload,
                                  to: moment(e.target.value, "YYYY-MM-DD").toISOString(),
                                })
                              }
                              className="form-control"
                              id="to"
                              name="to"
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <i className="fa fa-calendar" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group col-md-3">
                        <label
                          className="control-label text-purple"
                          htmlFor="btn"
                        >
                          `
                        </label>
                        <input
                          onClick={getUserActivity}
                          type="submit"
                          className="form-control btn-primary"
                          id="btn"
                          name="submit"
                          defaultValue="Sumbit"
                        />
                      </div>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    <table
                      id="example1"
                      className="table table-bordered table-striped"
                    >
                      <thead className="bg-gradient-yellow">
                        <tr>
                          <th>#</th>
                          <th>Code</th>
                          <th>Login Name</th>
                          <th>IPAddress</th>
                          <th>DateTime</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item?.userId}</td>
                            <td>{item?.userName}</td>
                            <td>{item?.ipAddress}</td>
                            <td>
                              {moment(item?.createdAt + "Z").format(
                                "YYYY-MM-DD HH:mm:ss"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot />
                    </table>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    </div>
  );
}
